// extracted by mini-css-extract-plugin
module.exports = {"addNewGroup":"EditGroup_addNewGroup__3YJXj","groupImage":"EditGroup_groupImage__3mBhs"};